import { AddDeviceToUnitQueryArg } from '../types/query-arg';
import { AddDeviceToUnitQueryBody } from '../types/query-body';

export const addDeviceToUnitQueryBody = ({
  device: { id },
  unitId,
}: AddDeviceToUnitQueryArg): AddDeviceToUnitQueryBody => ({
  actionType: 'AddToUnit',
  id,
  update: { unitId },
});
